import { updateProjectCallFlaggingConfigsDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const updateProjectCallFlaggingConfigsCallable = getCallable(
  updateProjectCallFlaggingConfigsDefinition,
);
